import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { TextStepHelpContent } from '../HelpContent';
import { jsx as _jsx } from "react/jsx-runtime";
export function TextStepItem({
  item,
  label,
  params,
  onChange
}) {
  var _item$tooltip;
  const value = params[item.name];
  return /*#__PURE__*/_jsx(FormControl, {
    label: label,
    required: item.required,
    tooltip: (_item$tooltip = item.tooltip) === null || _item$tooltip === void 0 ? void 0 : _item$tooltip.text,
    help: /*#__PURE__*/_jsx(TextStepHelpContent, {
      description: item.description,
      helpData: item.help
    }),
    children: /*#__PURE__*/_jsx(TextInput, {
      type: "text",
      onChange: event => onChange(item.name, event.target.value),
      value: value,
      placeholder: item.placeholder ? item.placeholder : null
    })
  });
}